import Vue, { CreateElement, RenderContext, VNode, VNodeData } from "vue";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default Vue.extend({
  name: "BaseButtonCreate",
  functional: true,
  render(h: CreateElement, ctx: RenderContext<{}>): VNode {
    let data: VNodeData = {
      class: [ctx.data.class, ctx.data.staticClass, "__create"],
      props: { round: true, ...ctx.props },
      attrs: ctx.data.attrs,
      on: ctx.listeners,
    };
    return h(BaseButton, data, [h(BaseIcon, ["sci-plus"])]);
  },
});
